import {
  startOfMonth, startOfWeek,
  addDays, addMonths, subMonths, addWeeks, subWeeks,
  format, isSameMonth, isToday, getDay
} from 'date-fns'
import { getHolidayName } from './koreanHolidays'

export type CalendarViewMode = 'month' | 'week' | 'agenda'

export interface CalendarDay {
  date: Date
  dateStr: string       // YYYY-MM-DD
  day: number           // day of month
  isCurrentMonth: boolean
  isToday: boolean
  isSunday: boolean
  isSaturday: boolean
  isHoliday: boolean
  holidayName?: string
}

export function getMonthGrid(monthDate: Date): CalendarDay[] {
  const monthStart = startOfMonth(monthDate)
  const calendarStart = startOfWeek(monthStart, { weekStartsOn: 0 })

  const days: CalendarDay[] = []
  for (let i = 0; i < 42; i++) {
    const date = addDays(calendarStart, i)
    const dateStr = format(date, 'yyyy-MM-dd')
    const holidayName = getHolidayName(dateStr)
    days.push({
      date,
      dateStr,
      day: date.getDate(),
      isCurrentMonth: isSameMonth(date, monthDate),
      isToday: isToday(date),
      isSunday: getDay(date) === 0,
      isSaturday: getDay(date) === 6,
      isHoliday: holidayName !== undefined,
      holidayName,
    })
  }
  return days
}

export function getMonthTitle(date: Date): string {
  return format(date, 'yyyy년 M월')
}

export function nextMonth(date: Date): Date {
  return addMonths(date, 1)
}

export function prevMonth(date: Date): Date {
  return subMonths(date, 1)
}

export function isSameDateStr(a: string, b: string): boolean {
  return a === b
}

/** 특정 날짜가 포함된 주의 7일 CalendarDay 배열 반환 */
export function getWeekGrid(date: Date): CalendarDay[] {
  const weekStart = startOfWeek(date, { weekStartsOn: 0 })
  const days: CalendarDay[] = []
  for (let i = 0; i < 7; i++) {
    const d = addDays(weekStart, i)
    const dateStr = format(d, 'yyyy-MM-dd')
    const holidayName = getHolidayName(dateStr)
    days.push({
      date: d,
      dateStr,
      day: d.getDate(),
      isCurrentMonth: true,
      isToday: isToday(d),
      isSunday: getDay(d) === 0,
      isSaturday: getDay(d) === 6,
      isHoliday: holidayName !== undefined,
      holidayName,
    })
  }
  return days
}

export function nextWeek(date: Date): Date {
  return addWeeks(date, 1)
}

export function prevWeek(date: Date): Date {
  return subWeeks(date, 1)
}

export const DAY_HEADERS = ['일', '월', '화', '수', '목', '금', '토']
